import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Table } from "semantic-ui-react";

const BookingImportLogs = (props) => {


    return (
        <>

            <div>
                <Modal open={props.openBox} onClose={props.handleClose} size="large">
                    <>
                        <Header>{"Import File Logs"}</Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Table>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>
                                                <label>Logs</label>
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {props.dataToLog.map((item, index) => (
                                            <Table.Row>
                                                <Table.Cell>
                                                    <Table.Row>
                                                        <Table.Cell>
                                                            {item}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                </Table.Cell>
                                            </Table.Row>

                                        ))}
                                    </Table.Body>
                                </Table>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={props.handleClose} size="mini">
                                {"Cancel"}
                            </Button>
                        </Modal.Actions>

                    </>
                </Modal>
            </div>

        </>
    );
};

export default BookingImportLogs;
